<div class="container-fluid">
  <app-login class="row" [hidden]="isLoggedIn == true"></app-login>
  @if (sp == 'overview') {
    <div id="overview" class="row">
      <h4>
        Welcome to the SCOHR (System for California Oral Health Reporting)
      </h4>
      <p>
        SCOHR was developed by the SJCOE (CodeStack Department) and in collaboration with the ACSA, CDA,
        and CCSESA, to provide a centralized online method of all required student oral health assessment data.<br><br>
        Schools in participating districts will have access to input, manage, and track electronic Oral Health
        Assessment/Waiver Request Forms and all oral health assessment data, bulk upload data to pre-fill the Oral Health
        Assessment/Waiver Request Forms, print pre-filled Oral Health Assessment/Waiver Request Forms (individually or
        in-bulk), and export all data into a standardized format.<br><br>
        SCOHR tracks the status of all Oral Health Assessment/Waiver Request Forms. SCOHR also includes a Report
        Generator utility to run ad-hoc, custom lists and aggregate reports at the school, district, county, and/or state
        levels.<br><br>
        If your school, district or COE is interested in participating, please contact the SJCOE, CodeStack Department, at
        <a href="mailto:scohr@sjcoe.net">scohr&#64;sjcoe.net</a>. To login, if your account has already been set up, enter
        your username and password into the fields above and click the Login button. If you need help logging in please
        <a href="mailto:scohr@sjcoe.net">contact our support</a> or call (866) 762-9170.
      </p>
    </div>
  }
  @if (sp == 'sjcoecodestack') {
    <div id="sjcoe-cedr">
      <h4>SJCOE/CodeStack</h4>
      <p>
        SCOHR is developed and operated by the San Joaquin County Office of Education, CodeStack Department. CodeStack is the developer and operator of EDJOIN, SEIS and many other online systems.
      </p>
    </div>
  }
  @if (sp == 'accessibility') {
    <div id="accessibility">
      <h4>Accessibility</h4>
      <p>
        Each user has a unique user name/user ID and password to login and access the system. Based on the login
        information the system will know the level of access granted and associated to that particular user name/user ID.
        Each user will have specific permissions set and all user activity will be logged to ensure the security of the
        system.<br><br>
        The system is comprised of a four-tier level of access which includes school level access, district wide access,
        county wide access, and state/system wide access. All school level, district level, and COE level users will be
        associated with their respective CDE codes. This structure determines which student records and reports each user
        name/user ID will have access to.<br><br>
        Within each school, district, and county there are another set of permissions, that can be set per user, to
        determine more specific access rights to student data (i.e. read-only access, user management access, and edit
        student record). Each participating entity will be designated one user account with user management access (to
        grant others access with user name/users ID, within their respective entity). All users are required to agree to
        a Term of Use statement before access is granted.
      </p>
    </div>
  }
  @if (sp == 'datacapture') {
    <div id="data-capture">
      <h4>Data Capture</h4>
      <p>
        SCOHR was designed to provide flexibility with regards to data input. Having worked with so many systems for
        school districts across California, SJCOE understands the reluctance of school districts to want to manually
        input data into another system for some sort of state reporting. Thus, as it has done for many other systems,
        SJCOE has developed an upload utility to allow districts to export all the required demographic and other data
        from their Student Information Systems, and bulk import them into SCOHR. Once the data is uploaded the system
        displays an exception report for the districts to indicate records that are possible duplicates, are missing
        required fields, etc. When manually entering, the system will also run a “duplicate check” on all student
        records.<br><br>
        SCOHR also has the ability to generate multiple Oral Health Assessment/Waiver Request Forms at once, or generate
        one for a single student. All Oral Health Assessment/Waiver Request Forms will be generated in a Portable
        Document Format (PDF). All demographic information will be required before an Oral Health Assessment/Waiver
        Request Form can be generated.<br><br>
        Once an Oral Health Assessment/Waiver Request Form is signed by a dentist and returned to the school, a user at
        the school must login into the system search within the schools “Pending Forms” section and input the signature
        date in the system to affirm.<br><br>
        For school districts that wish to track all student oral assessment data internally (i.e. within their Student
        Information System), once collected, they will have the ability to bulk upload all their student information
        including the form commencement date, oral health data, and dentist signature date.
      </p>
    </div>
  }
  @if (sp == 'reporting') {
    <div id="reporting">
      <h4>Reporting</h4>
      For the time being, the SJCOE has developed a custom report generator to provide aggregate real-time comparisons on all fields, and a custom search report to allow district and county wide users build an advanced query using a “drill-down” model to narrow down their totals. All reports can be saved and downloaded. SJCOE will also develop some standard aggregate reports. Once the system is implemented and used, the SJCOE will add other aggregate reports at the request of users. Furthermore, once the CDE identifies the data reports and formats it would like from the COE’s, SJCOE will include those in the system as well.<br><br>
      The district reporting requirements under AB1433 can be found at:
      <a href="http://www.cde.ca.gov/ls/he/hn/oralhlthdistrict.asp">http://www.cde.ca.gov/ls/he/hn/oralhlthdistrict.asp</a>.
      <br /><br />
      The System for California Oral Health Reporting (SCOHR) download forms are now available below.
      <br />
      <ul>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <li><a href="https://bit.ly/3OQ3ToF" target="_blank">Oral Health Assessment Form</a></li>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <li><a href="https://bit.ly/3QZbwKI" target="_blank">Waiver of Oral Health Assessment Requirement</a></li>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <li><a href="https://bit.ly/3y6jaKO" target="_blank">On-Site Dental Screenings Opt Out Letter</a></li>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <li><a href="https://bit.ly/3R0cKW8" target="_blank">Oral Health Notification Letter</a></li>
      </ul>
      <br />
      <!--Learn How to Use SCOHR: Data Input, Reports, and User Account Management <br /><br />
      <p class="center" width="50%">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/ntBHL2VsO1c" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      </p>-->
    </div>
  }
  <div id="sign-up"></div>
</div>
